import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useLenis from "@/hooks/useLenis";
import { trackVisit } from "@/lib/api";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Founders from "@/components/Founders";
import WhyLiver from "@/components/WhyLiver";
import Philosophy from "@/components/Philosophy"; // inactive for now — see hidden sections below
import LiverJourney from "@/components/LiverJourney";
import ColorRiskCategories from "@/components/ColorRiskCategories";
import PrecisionNutrition from "@/components/PrecisionNutrition"; // inactive for now — see hidden sections below
import Roadmap from "@/components/Roadmap";
import WhySuperAge from "@/components/WhySuperAge"; // inactive for now — see hidden sections below
import ImpactStats from "@/components/ImpactStats";
import Stories from "@/components/Stories"; // inactive for now — see hidden sections below
import Partners from "@/components/Partners"; // inactive for now — see hidden sections below
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ShareButton from "@/components/ShareButton";

export default function Home() {
  useLenis();
  const location = useLocation();

  // Count one website visit per browser session (refresh-safe).
  useEffect(() => {
    if (sessionStorage.getItem("sa_visited")) return;
    sessionStorage.setItem("sa_visited", "1");
    trackVisit("/").catch(() => {});
  }, []);

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      const scroll = () => {
        const el = document.getElementById(target);
        if (!el) return;
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -40 });
        else el.scrollIntoView({ behavior: "smooth" });
      };
      setTimeout(scroll, 500);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.state]);

  return (
    <div className="min-h-screen bg-sa-bg" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <ColorRiskCategories />
        <About />
        <Founders />
        <ImpactStats />
        <WhyLiver />
        <LiverJourney />
        <FinalCTA />
        <Roadmap />
        {/* Inactive for now (reactivate later): Philosophy, WhySuperAge, Partners, PrecisionNutrition, Stories */}
      </main>
      <Footer />
      <WhatsAppButton />
      <ShareButton />
    </div>
  );
}
